import React from 'react'
import useLocalStorage from './useLocalStorage';
import { BackendData } from '../Common/Utils/backendDataParser';

export default function useBackendData() {
  return useLocalStorage<(BackendData | undefined)>('selectedClient', undefined);
}